// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBMuoh6fWiukH8S4DJezSmeo5L_Vj0u9GM",
  authDomain: "my-portfolio-866fe.firebaseapp.com",
  projectId: "my-portfolio-866fe",
  storageBucket: "my-portfolio-866fe.firebasestorage.app",
  messagingSenderId: "948808575109",
  appId: "1:948808575109:web:838164c37b3f3d93dda1ec",
  measurementId: "G-C7T5Y4P33M"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db, analytics };